import { ElMessage } from "element-plus";
import bus from "vue3-eventbus";

import { useToggles } from "@/hooks/useToggles";
import { $t } from "@/plugins/i18n";
import { initTheme } from "@/utils/theme";

import { IChannelConfigs, IChannelTheme } from "../types";
import JcbFrame from "./components/index/JcbFrame.vue";
import UpgradeMembership from "./components/index/UpgradeMembership.vue";
const theme: IChannelTheme = {};

const isOpenJcbToggle = () => {
  const toggle = useToggles("HOTELUX_MATCH_JCB");
  return toggle.value;
};

const isOpenHyattToggle = () => {
  const toggle = useToggles("HOTELUX_HYATT_URGENT_NOTICE");
  return toggle.value;
};
export default {
  configs: {
    key: "hotelux",
    path: "hotel.hotelux.com",
    useChannelLogo: true,
    currency: "USD",
    telephoneCountryCode: "65",
    showLanguages: false,
    defaultLanguage: "en",
    nameFormatReverse: false,
    UserListnameReverse: false,
    isNoUpperCase: true,
    showCreditCardMatch: true,
    customUser: true,
    registerToSelectPage: true,
    NoShowBenefits: true,
    authGoogleWebClientId:
      "575776218865-n3k9fnqu2b2pedvj0p6m98ddofh7coa7.apps.googleusercontent.com",
    components: {
      IndexBeforeFeaturedHotels: {
        component: UpgradeMembership
      },
      CommonComponents: [
        {
          component: JcbFrame
        }
      ]
    },
    pages: {
      login: {
        bannerImageUrl:
          "https://qiniu-uploads-cdn.charmdeer.com/Sign_in_bj.webp",
        customizeBannerStyle: true
      },
      Index: {
        logoUrl:
          "https://qiniu-uploads-cdn.charmdeer.com/uploaded/FiTEe8ozRUpi4WfYmyY7nvcq5Cxm/hotelux-logo.png",
        banners: {
          autoplay: true,
          interval: 4000,
          list: [
            // 特典
            {
              img: "https://qiniu-uploads-cdn.charmdeer.com/banner-Hyatt.webp",
              title: "shared.hotel.notice.hyattTit",
              content: "shared.hotel.notice.hyatt",
              btn: "",
              show: () => {
                return isOpenHyattToggle();
              },
              onClick: () => {
                bus.emit("openJcbBenefitDrawer");
              }
            },
            {
              img: "https://qiniu-uploads-cdn.charmdeer.com/uploaded/FjcTn1ENZ4Sma585RdvnVgSRSOpD/bj-jcb.jpg",
              title: "shell.jcb.benefit.title",
              btn: "shell.common.details",
              show: () => {
                return isOpenJcbToggle();
              },
              onClick: () => {
                bus.emit("openJcbBenefitDrawer");
              }
            },
            // 优惠券活动
            {
              img: "https://qiniu-uploads-cdn.charmdeer.com/web-bj.webp",
              title: "shell.jcb.voucher.banner.title",
              subtitle: "shell.jcb.voucher.banner.subtitle",
              btn: "shell.common.details",
              show: () => {
                return isOpenJcbToggle();
              },
              onClick: ({ router }) => {
                router.push("/jcb/voucher");
              }
            },
            // 匹配
            {
              img: "https://qiniu-uploads-cdn.charmdeer.com/jcb-banner.png",
              title: "shell.jcb.banner.title",
              subtitle: "shell.jcb.banner.subtitle",
              btn: "shell.common.details",
              show: () => {
                return isOpenJcbToggle();
              },
              onClick: ({ router, userStore }) => {
                if (userStore.user.loyaltyProgram.ref.type === "guest") {
                  router.push("/external/callback/jcb?jcbInfo=none");
                } else {
                  ElMessage.warning(
                    $t("shared.auth.creditCard.guestMatchTips")
                  );
                }
              }
            }
          ]
        },
        featuredHotels: [
          "5b35eb5021b146b104fd6266", // 曼谷柏悦酒店
          "5b5077616a8860a3024e09d4", // 上海浦东文华东方酒店
          "5b5964218885d57e94df4c33", // 首尔新罗酒店
          "5b35e54d74b5e5b4a112b33c", // 东京丽思卡尔顿酒店
          "5b50e50312bd3f60197ea5a2", // 新加坡费尔蒙酒店
          "5b5073eb6a8860a3024de474", // 香港半岛
          "679350606279ad0aad3e6890" // 大阪柏典酒店
        ],
        JourneyList: [
          "5dab53d18dce6d537158d5a9", //Halekulani Okinawa
          "5b35e88d21b146b104fd2da2", //The Ritz-Carlton, Bali
          "66cedbcf281f2a375635c245", //The Osaka Station Hotel, Autograph Collection
          "5b5055c574de201bce684da6" //Regent Taipei
        ]
      },
      hotelDetail: {
        searchBar: {
          loaction: false
        },
        benefitsNoShowIcon: true
      },
      prepareOrder: {
        showOnline: false,
        arrivalTime: true,
        noShowPeerGuest: true,
        customMadeSex: true,
        FormatRule: true,
        noshowLWTips: true,
        isRuleLoyaltyCard: true,
        stripePay: true,
        ifShowPayOnline: true,
        hideSaveInfo: true
      },
      defaultOrderTab: true,
      orderList: {
        showGender: true,
        tab: [
          {
            nameI18n: {
              en: "All",
              jp: "全ての予約"
            },
            key: "all"
          },
          {
            nameI18n: {
              en: "Active",
              jp: "予約中"
            },
            key: "active"
          },
          {
            nameI18n: {
              en: "Past",
              jp: "利用履歴"
            },
            key: "past"
          },
          {
            nameI18n: {
              en: "Canceled",
              jp: "キャンセル"
            },
            key: "cancelled"
          }
        ]
      },
      orderDetail: {
        showCreditCardInfo: true,
        hlShowSendEmail: true,
        showTelephoneCountryCode: true
      }
    },
    airlineMatchJalRuleId: "6786169be533c5094d756ccd",
    airlineMatchSgRuleId: "6455ef3af26b526d1e3c239a",
    level: {
      guest: "https://uploads.ytripos.com/hl_level/guest_level.png",
      elite: "https://uploads.ytripos.com/hl_level/elite_level.png",
      elitePlus: "https://uploads.ytripos.com/hl_level/elitePlus_level.png",
      oneA: "https://uploads.ytripos.com/hl_level/1a_level.png"
    }
  },
  init() {
    initTheme(theme);
  }
} as IChannelConfigs;
